import type { VariantProps } from "@-/com.npmjs.cva";
import type { ViewProps } from "@-/com.npmjs.react-native";
import { badgeTextVariants, badgeVariants } from "#badge-variants";
import { TextClassContext } from "@-/dev.improve.haniverse.components.ui.text";
import { cn } from "@-/com.npmjs.cn";
import { Slot } from "@rn-primitives/slot";
import { View } from "@-/com.npmjs.react-native";

export type BadgeProps = ViewProps &
  React.RefAttributes<View> & {
    asChild?: boolean;
  } & VariantProps<typeof badgeVariants>;

export function Badge({ asChild, className, variant, ...props }: BadgeProps) {
  const Component = asChild ? Slot : View;
  return (
    <TextClassContext value={badgeTextVariants({ variant })}>
      <Component className={cn(badgeVariants({ variant }), className)} {...props} />
    </TextClassContext>
  );
}
